import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NvDesignLibraryModule } from 'Src/nvps-libraries/design/nv-design-library.module';
import { ListDisplayActivityModule } from '../../../../school/lists/list-display/list-display-activity/list-display-activity.module';
import { ActivitiesSettingsComponent } from './activities-settings.component';

@NgModule({
  imports: [CommonModule, NvDesignLibraryModule, ListDisplayActivityModule],
  declarations: [ActivitiesSettingsComponent],
  exports: [ActivitiesSettingsComponent],
})
export class ActivitySettingsModule {}
